import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import InfoSantaFe from "../nuevosantafe/InfoNuevoSantaFe";
const Footer = lazy(() => import('../footer/Footer'));
function SantaFe() {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="El nuevo Santa Fe es el SUV familiar perfecto. Cómodo, amplio, seguro, con diseño vanguardista y tecnológico. Disfruta los mejores momentos con tus seres queridos"
        />
        <meta
          name="keywords"
          content="Hyundai, Accent, Ioniq , Creta, Tucson, Santa Fe"
        />
        <title>Hyundai New Santa Fe</title>
      </Helmet>
      <Menu />
      <InfoSantaFe />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default SantaFe;